<app-crudbar-nav [title]="title" (onReady)="doComReady($event,'crudbar-nav')">
</app-crudbar-nav>

<mat-tab-group #masterTabGroup mat-stretch-tabs="false" mat-align-tabs="start" class="h-full"
  style="vertical-align: top;" animationDuration="0ms" dynamicHeight (selectedTabChange)="onMasterTabChange($event)">
  <mat-tab #myTabGrid label="瀏覽">
    <div class="border-2 border-red-300">
      <app-jkaggrid #myGrid [columnDefs]="srv.columnDefs" (afterGridReadyAg)="afterGridReady($event)"
        (rowClicked)="agRowClicked($event)" (rowSelected)="agRowSelected($event)" (onInsert)="doUIInsert($event)"
        (onDelete)="doUIDelete($event)"></app-jkaggrid>

    </div>
  </mat-tab>

  <mat-tab #myTabDetail label="明細">
    <!-- <app-mtrwc-tabedit [srv]="srv"></app-mtrwc-tabedit> -->
    <div style="max-height: 400px; overflow-y: auto;">
      <div class="jk-grid-cols-2">
        <app-jktext label="序號" [value]="item.WC003">
        </app-jktext>
        <app-jkdatefield label="日期" #WC004Com id="WC004" [(value)]="item.WC004" [readonly]="true">
        </app-jkdatefield>
        <app-jktextarea height="250px" label="問題敘述說明" #WC005Com id="WC005" [(value)]="item.WC005" [readonly]="true">
        </app-jktextarea>
        <app-jktextarea height="250px" label="處理說明" #WC006Com id="WC006" [(value)]="item.WC006" [readonly]="true">
        </app-jktextarea>
        <app-jktext label="單別" [value]="item.WC001">
        </app-jktext>
        <app-jktext label="單號" [value]="item.WC002">
        </app-jktext>

      </div>
    </div>
  </mat-tab>


  <mat-tab #myTabAdvance label="進階">
    <div class="border-2 min-h-[200px]">[空白]</div>
  </mat-tab>
</mat-tab-group>